import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "update-app text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " En ny version av applikationen är tillgänglig. Klicka på knappen nedan för att uppdatera. ", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateComponent',
  setup(__props) {

 
const updateApp = () => {
    navigator.serviceWorker.getRegistrations().then((registrations) =>{
        registrations[0].waiting?.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
    }); 
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      class: "btn",
      onClick: updateApp
    }, " Update ")
  ]))
}
}

})